<template>
  <div id="tradeLeadMessageList">
    <NavBar fixed title="消息" style="background-color: #f7f7f7">
      <template #left><Icon @click="allReturn()" name="arrow-left" size="22" color="#666"/></template>
<!--      <template #right><span @click="allSave()" style="color: rgba(212, 48, 48, 1)">清空</span></template>-->
    </NavBar>
    <div class="indiv" style="height: calc(100vh - 46px);overflow: auto;background-color: #f5f5f5;margin-top: 46px">
      <PullRefresh v-model="refreshing" @refresh="onRefresh">
        <List v-model="loading" :finished="finished" finished-text="没有更多消息了" @load="onLoad" sticky>
          <div class="CwwDiv">
            <ul>
              <li :key="index" v-for="(item, index) in list">
                <div>
                  <img :src="item.headUrl">
                </div>
                <div>
                  <div>
                    <p style="color: #576b95" class="font_14 magbot_2">{{item.nickName}}</p>
                    <p class="Champion_p" style="height: 31px">
                      <span v-if="parseInt(item.revertType) === 0" class="font_16">{{ item.content }}</span>
                      <Icon v-if="parseInt(item.revertType) === 1" name="like-o" size="18" color="#666"/>
                    </p>
                    <p>{{$commonJs.returnTimeago(item.createTime)}}</p>
                  </div>
                  <div class="textcenter" style="visibility: hidden">
                    <p>{{item.content}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </List>
      </PullRefresh>
    </div>
  </div>
</template>

<script>
import {Icon, List, PullRefresh, NavBar} from "vant";

export default {
  components: {
    PullRefresh,
    List,
    Icon,
    NavBar
  },
  name: 'tradeLeadMessageList',
  data () {
    return {
      list: [],
      page: 1,
      size: 20,
      error: false,
      loading: false,
      finished: false,
      refreshing: false
    }
  },
  created() {
  },
  methods: {
    allReturn () {
      this.$router.go(-1)
    },
    onRefresh(param) {
      this.finished = false;
      this.loading = true;
      this.onLoad(param);
    },
    onLoad(condition) {
      if (this.refreshing) {
        this.page = 1;
        this.list = [];
        this.refreshing = false;
      }
      const targetParam = {
        page: this.page++,
        size: this.size
      };
      this.$store.dispatch('getUnreadMessageList', {...targetParam, ...condition}).then(({rows, total}) => {
        this.list = [].concat(this.list, rows)
        if (this.list.length > 0) {
          for (let i = 0; i <  this.list.length; i++) {
            this.list[i].upUserInfos =  this.list[i].upUserInfos || []
            for (let j = 0; j < this.list[i].reverts.length; j++) {
              this.list[i].reverts[j].revertDetails = this.list[i].reverts[j].revertDetails || []
            }
          }
        }
        this.loading = false;
        if (this.list.length >= total) {
          this.finished = true;
        }
      }).catch(() => {
        this.loading = false;
        this.error = true
        this.finished = true;
      })
    },
  }
}
</script>

<style scoped>
.CwwDiv {}
.CwwDiv ul {
  background-color: white;
  padding: 10px 0 0 0;
}
.CwwDiv ul li {
  padding: 0 4% 10px 4%;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}
.CwwDiv ul li > div{
  display: inline-block;
  vertical-align: top;
}
.CwwDiv ul li > div:first-child {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin-right: 10px;
}
.CwwDiv ul li > div:first-child > img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.CwwDiv ul li > div:last-child {
  width: calc(100% - 56px);
  display: inline-block;
  vertical-align: middle;
}
.CwwDiv ul li > div:last-child > div:first-child {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}
.CwwDiv ul li > div:last-child > div:first-child p {
  line-height: normal;
}
.CwwDiv ul li > div:last-child > div:last-child {
  width: 70px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}
.CwwDiv ul li > div:last-child > div:last-child p {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  line-height: 18px;
}
</style>
